// extracted by mini-css-extract-plugin
module.exports = {"counter":"PlayersCounter_counter__oB1hZ"};